
export function getProjectNumberFromUrl(): string | undefined {
  const segments = window.location.pathname.split('/').filter(Boolean);
  return segments[0] === 'projects' ? segments[1] : undefined;
}

export function campaignListingPath(projectNumber?: string): string[] {
  return projectNumber
    ? ['/projects', projectNumber, 'email-campaign']
    : ['/email-campaign/campaign-listing'];
}

export function campaignTargetListingPath(campaignId: number | string, projectNumber?: string): string[] {
  return projectNumber
    ? ['/projects', projectNumber, 'email-campaign', 'target-listing', String(campaignId)]
    : ['/email-campaign/target-listing/' + campaignId];
}

export function campaignStagesPath(campaignId: number | string, projectNumber?: string): string[] {
  return projectNumber
    ? ['/projects', projectNumber, 'email-campaign', 'create-campaign-stages', String(campaignId)]
    : ['/email-campaign/create-campaign-stages/' + campaignId];
}
